import React, { Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import WidgetsLoader from './components/WidgetsLoader';
import StakingDetails from './pages/Staking/StakingDetails';
import PageNotFound from './components/PageNotFound';

const App: React.FC = () => {
  return (
    <Suspense fallback={<WidgetsLoader />}>
      <Routes>
        <Route path="/" element={<Navigate to="/staking" />} />
        {/* Corrected: Removed unnecessary redirect */}
        <Route path="/staking" element={<StakingDetails />}/> 
        <Route path="*" element={<Navigate to="/404" />} />
        <Route path="/404" element={<PageNotFound />} />
        {/* <Route path="/404" element={<PageNotFound />} />
        <Route path="*" element={<Navigate to="/404" />} /> */}
      </Routes>
    </Suspense>
  );
}

export default App;
